import {
  DisplayCommonConfigType,
  formatConfigUnmarshaller as CommonFormatUnmarshaller
} from './common';
import {
  formatConfigUnmarshaller as CommonImageUnmarshaller,
  ImageConfigType
} from './image';

import { formatConfigUnmarshaller as ImageBannerUnmarshaller } from './image/banner-320x50';
import { formatConfigUnmarshaller as ImageMPUUnmarshaller } from './image/medium-rectangle';
import { formatConfigUnmarshaller as ImageHeaderUnmarshaller } from './image/header-ad';
import { formatConfigUnmarshaller as ImageFooterUnmarshaller } from './image/footer-ad';
import { formatConfigUnmarshaller as ImageInterstitialUnmarshaller } from './image/interstitial';
import { commonInArticleConfig as CommonImageInArticleUnmarshaller } from './image/in-article/common-in-article.config';
import { formatConfigUnmarshaller as CommonImageInArticleMPUUnmarshaller } from './image/in-article/300x250';
import { formatConfigUnmarshaller as CommonImageInArticleRevealUnmarshaller } from './image/in-article/reveal';
import { formatConfigUnmarshaller as CommonImageInArticleLandscapeUnmarshaller } from './image/in-article/landscape';
import { formatConfigUnmarshaller as ImageOverlayThumbnailUnmarshaller } from './image/overlay-thumbnail';

import {
  formatConfigUnmarshaller as CommonRedirectUnmarshaller,
  RedirectConfigType
} from './redirect';
import { formatConfigUnmarshaller as RedirectBannerUnmarshaller } from './redirect/banner-320x50';
import { formatConfigUnmarshaller as RedirectMPUUnmarshaller } from './redirect/medium_rectangle';
import { formatConfigUnmarshaller as RedirectHeaderUnmarshaller } from './redirect/header-ad';
import { formatConfigUnmarshaller as RedirectFooterUnmarshaller } from './redirect/footer-ad';
import { formatConfigUnmarshaller as RedirectInterstitialUnmarshaller } from './redirect/interstitial';
import { commonInArticleConfig as CommonRedirectInArticleUnmarshaller } from './redirect/in-article/common-in-article.config';
import { formatConfigUnmarshaller as CommonRedirectInArticleLandscapeUnmarshaller } from './redirect/in-article/landscape';
import { formatConfigUnmarshaller as CommonRedirectInArticleRevealUnmarshaller } from './redirect/in-article/reveal';
import { formatConfigUnmarshaller as CommonRedirectInArticleMPUUnmarshaller } from './redirect/in-article/300x250';
import { formatConfigUnmarshaller as RedirectOverlayThumbnailUnmarshaller } from './redirect/overlay-thumbnail';

import { commonHeaderAd } from './common/header-ad';
import { commonFooterAd } from './common/footer-ad';
import { optOutBtnUnmarshaller } from './common/common-opt-out-btn';
import {
  leftUseCloseBtnRounded,
  rightUseCloseBtnRounded
} from './common/common-close-btn';

export interface DisplayRedirectConfigType
  extends DisplayCommonConfigType,
    RedirectConfigType {}
export interface DisplayImageConfigType
  extends DisplayCommonConfigType,
    ImageConfigType {}

export interface DisplayConfigType
  extends DisplayRedirectConfigType,
    DisplayImageConfigType {
  enableDynamicFooterResize?: boolean;
}

// Used for Building Creative Console Schema
export const formatConfigUnmarshaller = {
  // The key is indicative here, and not important for the process
  // Just to distinguish the cases
  banner_320x50_image: {
    // dirname is the output folder of the schema
    // inside the format folder
    // here it will be outputted inside "display/image/banner-320x50"
    dirname: 'banner_320x50/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...ImageBannerUnmarshaller
    },
    // this id is written inside the schema.json itself
    id: 'display/banner_320x50/image'
  },
  banner_320x50_redirect: {
    dirname: 'banner_320x50/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...RedirectBannerUnmarshaller
    },
    id: 'display/banner_320x50/redirect'
  },

  medium_rectangle_image: {
    dirname: 'medium_rectangle/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...ImageMPUUnmarshaller
    },
    id: 'display/medium_rectangle/image'
  },
  medium_rectangle_redirect: {
    dirname: 'medium_rectangle/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...RedirectMPUUnmarshaller
    },
    id: 'display/medium_rectangle/redirect'
  },
  header_ad_image: {
    dirname: 'header_ad/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...commonHeaderAd,
      ...CommonImageUnmarshaller,
      ...ImageHeaderUnmarshaller
    },
    id: 'display/header_ad/image'
  },
  footer_ad_image: {
    dirname: 'footer_ad/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...commonFooterAd,
      ...CommonImageUnmarshaller,
      ...ImageFooterUnmarshaller
    },
    id: 'display/footer_ad/image'
  },
  header_ad_redirect: {
    dirname: 'header_ad/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...commonHeaderAd,
      ...CommonRedirectUnmarshaller,
      ...RedirectHeaderUnmarshaller
    },
    id: 'display/header_ad/redirect'
  },
  footer_ad_redirect: {
    dirname: 'footer_ad/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...commonFooterAd,
      ...CommonRedirectUnmarshaller,
      ...RedirectFooterUnmarshaller
    },
    id: 'display/footer_ad/redirect'
  },
  interstitial_image: {
    dirname: 'interstitial/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...leftUseCloseBtnRounded,
      ...CommonImageUnmarshaller,
      ...ImageInterstitialUnmarshaller
    },
    id: 'display/interstitial/image'
  },
  interstitial_redirect: {
    dirname: 'interstitial/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...rightUseCloseBtnRounded,
      ...CommonRedirectUnmarshaller,
      ...RedirectInterstitialUnmarshaller
    },
    id: 'display/interstitial/redirect'
  },
  in_article_300x250_image: {
    dirname: 'in_article/300x250/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...CommonImageInArticleUnmarshaller,
      ...CommonImageInArticleMPUUnmarshaller
    },
    id: 'display/in_article/300x250/image'
  },
  in_article_300x250_redirect: {
    dirname: 'in_article/300x250/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...CommonRedirectInArticleUnmarshaller,
      ...CommonRedirectInArticleMPUUnmarshaller
    },
    id: 'display/in_article/300x250/redirect'
  },
  in_article_reveal_image: {
    dirname: 'in_article/reveal/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...CommonImageInArticleUnmarshaller,
      ...CommonImageInArticleRevealUnmarshaller
    },
    id: 'display/in_article/reveal/image'
  },
  in_article_reveal_redirect: {
    dirname: 'in_article/reveal/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...CommonRedirectInArticleUnmarshaller,
      ...CommonRedirectInArticleRevealUnmarshaller
    },
    id: 'display/in_article/reveal/redirect'
  },
  in_article_landscape_redirect: {
    dirname: 'in_article/landscape/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...CommonRedirectInArticleUnmarshaller,
      ...CommonRedirectInArticleLandscapeUnmarshaller
    },
    id: 'display/in_article/landscape/redirect'
  },
  in_article_landscape_image: {
    dirname: 'in_article/landscape/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...CommonImageInArticleUnmarshaller,
      ...CommonImageInArticleLandscapeUnmarshaller
    },
    id: 'display/in_article/landscape/image'
  },
  overlay_thumbnail_image: {
    dirname: 'overlay_thumbnail/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...ImageOverlayThumbnailUnmarshaller
    },
    id: 'display/overlay_thumbnail/image'
  },
  overlay_thumbnail_redirect: {
    dirname: 'overlay_thumbnail/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...RedirectOverlayThumbnailUnmarshaller
    },
    id: 'display/overlay_thumbnail/redirect'
  },
  standard_banners_image: {
    dirname: 'standard_banners/image',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonImageUnmarshaller,
      ...ImageBannerUnmarshaller
    },
    id: 'display/standard_banners/image'
  },
  standard_banners_redirect: {
    dirname: 'standard_banners/redirect',
    config: {
      ...CommonFormatUnmarshaller,
      ...optOutBtnUnmarshaller,
      ...CommonRedirectUnmarshaller,
      ...RedirectBannerUnmarshaller
    },
    id: 'display/standard_banners/redirect'
  }
};

// Used for runtime unmarshalling
// key is formatted such as ${adUnitType}/${subconfig ...}
export const formatUnmarshaller = {
  'banner_320x50/image': formatConfigUnmarshaller.banner_320x50_image.config,
  'banner_320x50/redirect':
    formatConfigUnmarshaller.banner_320x50_redirect.config,

  'medium_rectangle/image':
    formatConfigUnmarshaller.medium_rectangle_image.config,
  'medium_rectangle/redirect':
    formatConfigUnmarshaller.medium_rectangle_redirect.config,

  'header_ad/image': formatConfigUnmarshaller.header_ad_image.config,
  'header_ad/redirect': formatConfigUnmarshaller.header_ad_redirect.config,

  'footer_ad/image': formatConfigUnmarshaller.footer_ad_image.config,
  'footer_ad/redirect': formatConfigUnmarshaller.footer_ad_redirect.config,

  'interstitial/image': formatConfigUnmarshaller.interstitial_image.config,
  'interstitial/redirect':
    formatConfigUnmarshaller.interstitial_redirect.config,

  'in_article/300x250/image':
    formatConfigUnmarshaller.in_article_300x250_image.config,
  'in_article/300x250/redirect':
    formatConfigUnmarshaller.in_article_300x250_redirect.config,
  'in_article/reveal/image':
    formatConfigUnmarshaller.in_article_reveal_image.config,
  'in_article/reveal/redirect':
    formatConfigUnmarshaller.in_article_reveal_redirect.config,
  'in_article/landscape/image':
    formatConfigUnmarshaller.in_article_landscape_image.config,
  'in_article/landscape/redirect':
    formatConfigUnmarshaller.in_article_landscape_redirect.config,

  'overlay_thumbnail/image':
    formatConfigUnmarshaller.overlay_thumbnail_image.config,
  'overlay_thumbnail/redirect':
    formatConfigUnmarshaller.overlay_thumbnail_redirect.config,

  'standard_banners/image':
    formatConfigUnmarshaller.standard_banners_image.config,
  'standard_banners/redirect':
    formatConfigUnmarshaller.standard_banners_redirect.config

  // "in_article/interscroller/image": ...
};
